import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function AuthCallback() {
  const { loginGoogle } = useAuth();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login"); return; }
    loginGoogle(decodeURIComponent(m[1]))
      .then(() => { window.history.replaceState(null, "", "/"); nav("/"); })
      .catch((err) => {
        const msg = err?.response?.data?.detail;
        toast.error(typeof msg === "string" ? msg : "Accesso Google non riuscito");
        window.history.replaceState(null, "", "/login");
        nav("/login");
      });
  }, [loginGoogle, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <p className="text-muted-foreground animate-pulse">Accesso in corso…</p>
    </div>
  );
}
